"use client";

import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import clsx from "clsx";
import { FC, Fragment } from "react";

export interface ModalProps {
  isOpen: boolean;
  setIsOpen?: (isOpen: boolean) => void;
  className?: string;
  blur?: boolean;
  maxWidth?: number | string;
  fillMobile?: boolean;
  padding?: boolean;
  children?: any;
}

export const ModalTitle: FC<any> = (props) => {
  return <DialogTitle {...props} />;
};

export const ModalDescription: FC<any> = (props) => {
  return <Description {...props} />;
};

const Modal = ({
  fillMobile,
  isOpen,
  setIsOpen,
  children,
  className,
  blur,
  padding = true,
  maxWidth,
}: ModalProps) => {
  return (
    <Transition appear show={isOpen} as={Fragment as any}>
      <Dialog onClose={() => setIsOpen && setIsOpen(false)}>
        <TransitionChild
          as={Fragment as any}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={clsx(
              "fixed w-screen h-screen flex justify-center items-center bg-neutral-875 bg-opacity-25 top-none left-none z-50",
              {
                "backdrop-blur-sm": blur,
              },
            )}
          ></div>
        </TransitionChild>

        <div className="fixed inset-none flex h-screen-safe items-center justify-center z-50">
          <TransitionChild
            as={Fragment as any}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div
              className={clsx("flex flex-1 justify-center", {
                "h-full m:h-auto": fillMobile,
              })}
            >
              <DialogPanel
                style={{ maxWidth }}
                className={clsx(
                  "bg-neutral-0 flex flex-col gap overflow-y-auto shadow-3",
                  {
                    "h-full w-screen m:w-auto m:h-auto m:max-w-[700px] m:max-h-[calc(100vh-32px)] items-center":
                      fillMobile,
                    "m:max-h-[calc(100vh-32px)] max-w-[700px]": !fillMobile,
                    "m:rounded-m m:m-s": fillMobile,
                    "m-s rounded-m": !fillMobile,
                    "p-2s s:p-2m": padding,
                  },
                  className,
                )}
              >
                {children}
              </DialogPanel>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
};

export default Object.assign(Modal, {
  Title: ModalTitle,
  Description: ModalDescription,
});
